import { gql } from '@src/lib/gql'

export const INVITE_ADVISOR_TO_BOARD = gql`
  mutation InviteAdvisorToBoard($input: InviteAdvisorToBoardInput!) {
    inviteAdvisorToBoard(input: $input) {
      advisorEngagement {
        id
        advisorEngagementId
        statusKey
        status {
          id
          key
          title
        }
      }
    }
  }
`
